import { RenderElementProps } from 'slate-react';

export const ELEMENT_IMAGE_SLIDE_TEXT = 'image-slide-text';
export const ELEMENT_IMAGE_SLIDE_TEXT_INPUT = 'image-slide-text-input';

export interface ImageSlideTextPluginOptions {
  isReadOnly?: boolean;
}
export interface ImageSlideTextPluginElementProps
  extends RenderElementProps,
    ImageSlideTextPluginOptions {}
